import type { FeatureGeometriesMachine } from '@/features/execute-calculation-set/overmind/arcgis/featureGeometries';

import type { ContainmentGrid } from '../../index';
import { Features } from '../../createGridElementCalculationSetExecutionDetails';

export function getSubstationName(
  containment: ContainmentGrid,
  features: Features
):
  | { type: 'SUBSTATION_NAME'; name: string }
  | { type: 'SUBSTATION_NAME_NOT_FOUND' } {
  if (!features.any())
    return { type: 'SUBSTATION_NAME_NOT_FOUND' };

  const substation = containment.find(
      containment =>
        containment.containerType === 'Substation' &&
        features.findFeature(containment.containerId)
  )

  if(substation) {
    const gridElement = features.findFeature(substation.containerId);
    if (gridElement) {
      return { type: 'SUBSTATION_NAME', name: gridElement.gc.title || gridElement.gc.globalId };
    }
    return { type: 'SUBSTATION_NAME_NOT_FOUND' };
  }

  return { type: 'SUBSTATION_NAME_NOT_FOUND' };
}
